import { useContext, useEffect, useState } from "react";
import { useApi } from "../../hooks/useApi";
import InputPasswordComp from "../inputs/input/InputPasswordComp";
import FeedbackContext from "../../contexts/eventFeedback";
import PixelEdumanLoader from "../loading/PixelEdumanLoader";
import ActiveUsers from "../activeUsers/ActiveUsers";
import cardIcon from "../../assets/images/icons/misc/card-image.svg";

const AccountInfo = ({accountInfo, refreshAccessToken, userObj, logout, avatar}) => {
    const { fetchGet, fetchPost } = useApi();
    const [editing, setEditing] = useState(false);
    const [editText, setEditText] = useState(true);
    const [passwordChange, setPasswordChange] = useState(false);
    const [passwordContentForm, setPasswordContentForm] = useState({
        currPassword: "",
        newPassword: "",
        reNewPassword: "",
    })
    const [loading, setLoading] = useState(true);

    const {queueMessage} = useContext(FeedbackContext);

    const [subIcons, setSubIcons] = useState([]);

    const resetPasswordContentForm = () => {
        setPasswordContentForm({
            currPassword: "",
            newPassword: "",
            reNewPassword: "",
        });
    }

    const updatePasswordFunction = (e, field, value) => {
        if(field) {
            setPasswordContentForm(prev => ({
                ...prev,
                [field]: value
            }));
        }
    };

    const passwordSubmitForm = async (e, endpoint, payload) => {
        e.stopPropagation();
        
        setLoading(true);
        const data = await fetchPost(endpoint, payload); 

        queueMessage(data);
        
        setLoading(false);
        
        setPasswordChange((data?.type === "success" ? false : true));
    }

    const submitPasswordChange = async (e) => {
        await passwordSubmitForm(e, "/routes/api/users/action/passwordChange/", {data: passwordContentForm});
    }

    const submitPasswordReset = async (e) => {
        await passwordSubmitForm(e, "/routes/api/sessions/resetPass/", {email: userObj?.email}); 
    }

    const accountInfoUpdateHandler = async (e) => {
        const formEl = document.getElementById("accountInfoForm");
        const formData = Object.fromEntries(new FormData(formEl).entries());

        await fetchPost(`/routes/api/header/update/`, formData, true);
        
        // const { token } = await fetchPost(`/routes/api/sessions/refreshAllTokens/`, {}, true);

        // localStorage.setItem('accessTokenEduhero', token);


        // const refreshedData = await fetchGet(`/routes/api/sessions/validateUserData/`);        

        // setUserInfo({
        //     first_name: refreshedData.data.first_name,
        //     last_name: refreshedData.data.last_name,
        //     email: refreshedData.data.email,
        // });

        await refreshAccessToken();
        setEditing(false);
        
    }

    useEffect(() => {
        if(userObj) {
            setLoading(false);            
        }
        if (!userObj?.subscriptions?.length) {
            setSubIcons([]);
            return;
        }
        const objUrls = [];
        const loadIcons = async () => {
            const currIcons = userObj.subscriptions.flatMap(
                s => s.icons || []
            );
            const resovledIcons = await Promise.all(
                currIcons.map(async ({ icon, name }) => {
                    try {
                        if (icon === '') {
                            return { name, url: cardIcon  }
                        }
                        const img = await fetchPost(
                            `/routes/api/files/actions/getFile`,
                            { path: icon }
                        );
                        if(!(img instanceof Blob)) {
                            return { name, url: null };
                        }
                        const objUrl = URL.createObjectURL(img);
                        objUrls.push(objUrl);
                        return { name, url: objUrl };
                    } catch (err) {
                        console.error('Error loading subscription icons: ', err);
                        return { name, url: null };
                        
                    }
                })
            )
            setSubIcons(resovledIcons);
        }
        loadIcons();
        return () => {
            objUrls.forEach(url => {
                URL.revokeObjectURL(url)
            });
        };
    }, [userObj]);

    useEffect(() => {
        if(!accountInfo) {
            setLoading(false);
            setPasswordChange(false);
            resetPasswordContentForm();
            setEditing(false);
            setEditText(true);
        }
    }, [accountInfo]);

    useEffect(() => {
        if(!passwordChange) {
            resetPasswordContentForm();
            setLoading(false);
        }
    }, [passwordChange])

    return <>
        {accountInfo && 
            <section id='accountInfo' className='accountInfo2 flex flexColumn flexAlignCenter'>
                <div className="accountInfo2Wrapper flex flexColumn flexCenter">
                    <h2 className='accountInfoTitle'>Account</h2>
                    { editing && 
                        <div className="flex flexCenter accountInfoEditingTabContainer">
                            <button type="button" className={"accountInfoEditingTab " + (editText ? "accountTabSelected" : "")} onClick={
                                () => setEditText(true)
                            }>
                                Information
                            </button>
                            <button type="button" className={"accountInfoEditingTab " + (editText ? "" : "accountTabSelected")} onClick={
                                () => setEditText(false)
                            }>
                                Images
                            </button>
                        </div>
                    }
                    { (!editing || (editing && !editText)) && 
                        <div className='avatarImgContainer accountInfoAvatar'>
                            <img src={avatar} id="avatar" alt="avatar" />
                        </div>
                    }
                    { editing ?
                            <>
                                {editText &&
                                    <form id='accountInfoForm' className='accountInfoForm flex flexColumn flexCenter' autoComplete="false">
                                        <div className="accountInfoInputWrapper flex flexColumn flexJustifyCenter flexAlignStart">
                                            <label htmlFor="firstName" className='accountInfoLabel'><span className='accountInfo2Label'>first name:</span> </label>
                                            <input type="text" name="firstName" id="accountInfoFirstName" className='accountInfoInput' max="30" defaultValue={userObj && userObj?.first_name ? userObj.first_name : "" } />
                                        </div>
                                        <div className="accountInfoInputWrapper flex flexColumn flexJustifyCenter flexAlignStart">
                                            <label htmlFor="lastName" className='accountInfoLabel'><span className='accountInfo2Label'>last name:</span> </label>
                                            <input type="text" name="lastName" id="accountInfoLastName" className='accountInfoInput' max="30" defaultValue={userObj && userObj?.last_name ? userObj.last_name : "" } />
                                        </div>
                                        <div className="accountInfoInputWrapper flex flexColumn flexJustifyCenter flexAlignStart">
                                            <label htmlFor="email" className='accountInfoLabel'><span className='accountInfo2Label'>email:</span> </label>
                                            <input type="email" name="email" id="accountInfoEmail" className='accountInfoInput' defaultValue={userObj && userObj?.email ? userObj.email : "" } />
                                        </div>
                                    </form>
                                }
                            </>
                        :
                            <div className="accountInfoDataContainer">
                                <div className='flex flexColumn'>
                                    <div className="flex flexColumn flexJustifyCenter flexAlignStart">
                                        <span className='accountInfo2Label'>First Name:</span>
                                        <div className="accountInfoData">
                                            {(userObj && userObj?.first_name) ? userObj.first_name : "---" }
                                        </div>
                                    </div>
                                    <div className="flex flexColumn flexJustifyCenter flexAlignStart">
                                        <span className='accountInfo2Label'>Last Name:</span>
                                        <div className="accountInfoData">
                                            {(userObj && userObj?.last_name) ? userObj.last_name : "---"}
                                        </div>
                                    </div>
                                    <div className="flex flexColumn flexJustifyCenter flexAlignStart">
                                        <span className='accountInfo2Label'>Email:</span>
                                        <div className="accountInfoData">
                                            {(userObj && userObj?.email) ? userObj.email : "---"}
                                        </div>
                                    </div>
                                    <div className="flex flexColumn flexJustifyCenter flexAlignStart">
                                        <span className='accountInfo2Label'>Role:</span>
                                        <div className="accountInfoData">
                                            {userObj?.permission_names ? userObj.permission_names.join(", ") : "---"}
                                        </div>
                                    </div>
                                    <div className="flex flexColumn flexJustifyCenter flexAlignStart">
                                        {   !passwordChange ?
                                                <>
                                                    <span className='accountInfo2Label'>Password:</span>
                                                    <div className="accountInfoData">
                                                        <button type="button" className="changePassword-button" onClick={(e) => {e.stopPropagation(); setPasswordChange(true);}}>Change</button>
                                                    </div>
                                                </>
                                            :
                                                <>
                                                    <form id='loginForm' name={"loginForm"} type="submit" className="flex flexColumn" onSubmit={(e) => {
                                                        e.stopPropagation();
                                                        e.preventDefault();
                                                        submitPasswordChange(e);
                                                    }}>
                                                        <span className='accountInfo2Label'>Password Change:</span>
                                                        
                                                        <div className="accountInfoData">
                                                            <button 
                                                                type="button" 
                                                                className="changePassword-button" 
                                                                onClick={submitPasswordReset}
                                                            >
                                                                Request Link
                                                            </button>
                                                        </div>

                                                        <span htmlFor="currPassword" className="accountInfo2Label">Current Password</span>
                                                        <InputPasswordComp name={"currPassword"} field={"currPassword"} updateFunction={updatePasswordFunction} value={passwordContentForm.currPassword} form={"loginForm"} />

                                                        <span className="accountInfo2Label">New Password</span>
                                                        <InputPasswordComp name={"newPassword"} field={"newPassword"} updateFunction={updatePasswordFunction} value={passwordContentForm.newPassword} form={"loginForm"} />

                                                        <span className="accountInfo2Label">Re-Enter New Password</span>
                                                        <InputPasswordComp name={"reNewPassword"} field={"reNewPassword"} updateFunction={updatePasswordFunction} value={passwordContentForm.reNewPassword} form={"loginForm"} />

                                                        <div className="accountInfoData">
                                                            <button 
                                                                type="button" 
                                                                className="changePassword-button" 
                                                                onClick={(e) => {
                                                                    e.stopPropagation()
                                                                    setPasswordChange(false)
                                                                }}
                                                            >
                                                                Cancel
                                                            </button>
                                                            <button 
                                                                type="button" 
                                                                className="changePassword-button" 
                                                                onClick={(e) => {
                                                                    e.stopPropagation()
                                                                    submitPasswordChange(e);
                                                                }}
                                                            >
                                                                Submit
                                                            </button>
                                                        </div>
                                                    </form>
                                                </>
                                        }
                                    </div>
                                </div>    
                                <div className='flex flexColumn'>
                                    <div className="flex flexColumn flexJustifyCenter flexAlignStart">
                                        <span className='accountInfo2Label'>Subscriptions:</span>
                                        <div className="accountUserSubscriptions">
                                            {subIcons && (
                                                subIcons.map((item, idx) => (
                                                    item.url && (
                                                        <img 
                                                            key={`${item.name}-${idx}`}
                                                            src={item.url}
                                                            alt={item.name}
                                                            title={`Icon for ${item.name}`}
                                                        />
                                                    )
                                                ))
                                            )}
                                            {/* {(userObj && userObj?.subscriptions) && (
                                                userObj.subscriptions.map(s => (
                                                    <img src={s.icons.icon} alt={s.icons.name} />
                                                ))
                                            )} */}
                                        </div>
                                    </div>    
                                    {/* TODO: add Date Joined*/}
                                </div>
                            </div>
                    }
                    <div className='flex flexCenter accountInfoButtonContainer'>
                        {editing ?
                                <div className='accountInfoEditButtonsContainer flex flexJustifySpaceBetween flexAlignCenter'>
                                    <button id='accountInfoSave' onClick={accountInfoUpdateHandler} className='accountInfoSave' type='button'>Save</button>
                                    <button id='accountInfoCancel' onClick={() => setEditing(false)} className='accountInfoCancel' type='button'>Cancel</button>
                                </div>
                            :
                                <button id='accountInfoEdit' onClick={() => setEditing(true)} className='accountInfoEdit' type="button">Edit</button>
                        }
                        <button type='button' className="logout" onClick={logout}>LOGOUT</button>
                    </div>
                </div>
                <ActiveUsers />
                {   loading &&
                    <PixelEdumanLoader isAbsolute={true} message={"Loading..."} />
                }
            </section>
        }
    </>;
};

export default AccountInfo;